interface IExportCategory {
    key: string;
    label: string;
}

const AvailableExportCategories: IExportCategory[] = [
    { key: "AlertsAndSpecialNeeds", label: "AlertsAndSpecialNeedsLabel" },
    { key: "AllergiesAndAdverseReactions", label: "AllergiesAndAdverseReactionsLabel" },
    { key: "Appointments", label: "AppointmentsLabel" },
    { key: "CareElements", label: "CareElementsLabel" },
    { key: "ClinicalNotes", label: "ClinicalNotesLabel" },
    { key: "FamilyHistory", label: "FamilyHistoryLabel" },
    { key: "Immunizations", label: "ImmunizationsLabel" },
    { key: "LaboratoryResults", label: "LaboratoryResultsLabel" },
    { key: "MedicationsAndTreatments", label: "MedicationsAndTreatmentsLabel" },
    { key: "PastHealth", label: "PastHealthLabel" },
    { key: "PersonalHistory", label: "PersonalHistoryLabel" },
    { key: "ProblemList", label: "ProblemListLabel" },
    { key: "Reports", label: "ReportsLabel" },
    { key: "RiskFactors", label: "RiskFactorsFullLabel" }
];

export { AvailableExportCategories, IExportCategory };
